"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageTransport = void 0;
const MockWindow_1 = require("../MockWindow");
const __1 = require("..");
const Origin_1 = require("../types/Origin");
const Transport_1 = require("./Transport");
class PostMessageTransport extends Transport_1.Transport {
    constructor(name) {
        super(name);
        this.type = __1.TransportType.POST_MESSAGE;
        this.init().catch((error) => console.error(error));
    }
    static async isAvailable() {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const fn = (event) => {
                const data = event.data;
                if (data && data.payload === 'pong') {
                    resolve(true);
                    MockWindow_1.myWindow.removeEventListener('message', fn);
                }
            };
            MockWindow_1.myWindow.addEventListener('message', fn);
            const message = {
                target: __1.ExtensionMessageTarget.EXTENSION,
                payload: 'ping'
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            MockWindow_1.myWindow.postMessage(message, '*');
        });
    }
    async init() {
        MockWindow_1.myWindow.addEventListener('message', (message) => {
            if (typeof message === 'object' && message) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const data = message.data;
                if (data.message && data.message.target === __1.ExtensionMessageTarget.PAGE) {
                    this.notifyListeners(data.message.payload, {
                        origin: Origin_1.Origin.EXTENSION,
                        id: data.sender.id || ''
                    }).catch((error) => {
                        throw error;
                    });
                }
            }
        });
    }
    async send(message, _recipient) {
        const data = {
            target: __1.ExtensionMessageTarget.EXTENSION,
            payload: message
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        MockWindow_1.myWindow.postMessage(data, '*');
    }
}
exports.PostMessageTransport = PostMessageTransport;
//# sourceMappingURL=PostMessageTransport.js.map